



















import Vue from "vue";
import Component from "vue-class-component";
import Wit from "./Wit.vue";
import GoogleSpeech from "./GoogleSpeech.vue";

@Component({
  components: {
    Wit,
    GoogleSpeech
  }
})
export default class Recognition extends Vue {
  currentTab = 0;
}
